<template>
  <b-modal id="detView" title="Update Part B" size="lg" centered v-model="showModal">
    <basic-e-w-b-details v-bind:ewaybill="ewaybill"></basic-e-w-b-details>
      <h4>Part B</h4>
    <form>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <label for="vehicleNo">Vehicle Number</label>
            <input type="text" class="form-control" id="vehicleNo" v-model="vehicleNo">
          </div>
        </div>
        <div class="col">

          <div class="form-group">
            <label for="transhipmentLocation">Transhipment Location</label>
            <input type="text" class="form-control" id="transhipmentLocation" v-model="transhipmentLocation">
          </div>
        </div>
      </div>
    </form>
      <div v-if="modal.isError">
        <div class="alert alert-danger" role="alert">
          Updating part B failed. {{ modal.errorMsg }}
        </div>
      </div>
      <div v-if="modal.isSuccess">
        <div class="alert alert-success" role="alert">
          Part B updated.
        </div>
      </div>
      <div v-if="modal.inProgress">
        <div class="text-center">
          Updating Part B. Please wait...
        </div>
        <br>
        <div class="text-center">
          <span class="fa fa-spinner fa-spin fa-3x"></span>
        </div>
      </div>

      <div slot="modal-footer" class="w-100">
        <div class="float-right">
          <button class="btn btn-secondary" @click="closeModal()" v-if="!modal.inProgress">
         <i class="fa fa-times"></i>   Dismiss
          </button>
          <button class="btn btn-secondary" @click="closeModal()" v-if="modal.isSuccess">
            <i class="fa fa-times"></i>   Close
          </button>
          <button v-if="!modal.isSuccess" :disabled="modal.inProgress" class="btn btn-primary" @click="updatePartB(ewaybill)">
           <i class="fa fa-truck"></i>  Update PartB
          </button>
        </div>
      </div>

  </b-modal>
</template>

<script>
import axios from 'axios'
import { StringUtils } from '../../utils/util'
import BasicEWBDetails from '@/components/shared/BasicEWBDetails'

let apiUrl = process.env.NODE_ENV === 'production' ? 'https://api.e-waybill.in' : 'http://localhost:36508'
let uuid = () => {
  return Math.random().toString(36).substring(2, 15)
}

export default {
  name: 'UpdatePartB',
  components: { BasicEWBDetails },
  props: ['ewaybill', 'credential'],
  data () {
    return {
      showModal: true,
      modal: {
        inProgress: false,
        isError: false,
        isSuccess: false,
        errorMsg: ''
      },
      transhipmentLocation: '',
      vehicleNo: ''
    }
  },
  methods: {
    updatePartB: function () {
      let e = this.ewaybill

      // sanitize vehicleNo
      const sanitizedVehicleNumber = StringUtils.sanitizeVehicleNumber(this.vehicleNo)

      // validate vehicle number
      axios.get(`${apiUrl}/api/vehicle?vehicle=${sanitizedVehicleNumber}`).then(response => {
        if (!response.data[sanitizedVehicleNumber]) {
          this.modal.errorMsg = 'Invalid vehicle number'
          this.modal.isError = true
          this.modal.inProgress = false
          return
        }
        // make update
        let payload = {
          requestId: uuid(),
          credentials: {
            userName: this.credential.userName,
            password: this.credential.password,
            gstNumber: this.credential.gstNumber,
            loginType: 'TXP'
          },
          ewaybillNos: [this.ewaybill.ewb],
          vehicleNo: sanitizedVehicleNumber,
          transhipmentLocation: this.transhipmentLocation
        }
        this.modal.inProgress = true
        axios.post(`${apiUrl}/api/e-waybill/update`, payload).then(response => {
          // check the status until completed
          let interval = setInterval(() => {
            axios.get(`${apiUrl}/api/e-waybill/update-status?request_id=${payload.requestId}`).then(response => {
              const data = response.data
              if (data.status === 'COMPLETED') {
                clearInterval(interval)
                if (data.successForms.includes(e.ewb)) {
                  this.modal.inProgress = false
                  this.modal.isSuccess = true
                  axios.post(`/app/ewb/history`, {
                    ewb: e.ewb,
                    location: this.transhipmentLocation,
                    date: new Date(),
                    historyType: 'PARTB'
                  }).then(response => console.log(response), error => console.error(error))
                  this.$emit('updateComplete', data)
                } else {
                  this.modal.isError = true
                  this.errorMsg = data.errors[e.ewb]
                }
              }
            })
          }, 5000)
        }, error => {
          console.error('Error in updating part b', error)
          this.modal.errorMsg = 'Unable to update part B, Try after sometime'
          this.modal.isError = true
          this.modal.inProgress = false
        })
      }, error => {
        console.error('Error in updating part b', error)
        this.modal.errorMsg = 'Unable to update part B, Try after sometime'
        this.modal.isError = true
        this.modal.inProgress = false
      })
    },
    closeModal: function () {
      // reset state
      this.modal.inProgress = false
      this.modal.isError = false
      this.modal.isSuccess = false
      this.modal.errorMsg = ''

      this.$emit('dialogClosed', {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/UpdatePartB.vue